import { render, staticRenderFns } from "./QuotePaymentsHitoryList.vue?vue&type=template&id=4023247a&scoped=true&"
import script from "./QuotePaymentsHitoryList.vue?vue&type=script&lang=js&"
export * from "./QuotePaymentsHitoryList.vue?vue&type=script&lang=js&"
import style0 from "./QuotePaymentsHitoryList.vue?vue&type=style&index=0&id=4023247a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023247a",
  null
  
)

export default component.exports